import styled from '@emotion/styled'
import { APP_BRANDS, useAppBrand } from '@vivaldis/common'
import VivaldisLogoTypeAsset from './assets/vivaldis-logotype.svg'
import BrickjobsLogoTypeAsset from './assets/brickjobs-logotype.svg'
import { LogoProps } from './typings/LogoProps'

export const Logo = ({ width = 92 }: LogoProps) => {
  const appBrand = useAppBrand()

  return (
    <Image
      src={
        appBrand === APP_BRANDS.BrickJobs
          ? BrickjobsLogoTypeAsset
          : VivaldisLogoTypeAsset
      }
      width={width}
    />
  )
}

const Image = styled('img')<{ width: number }>`
  width: ${({ width }) => `${width}px`};
  height: ${({ width }) => `${Math.round(width / 1.92)}px`};
`
